export interface StockPriceIex {
    stockTimestamp: Date;
    stockDate: Date;
    symbol: string;
    companyName: string;
    primaryExchange: string;
    calculationPrice: string;
    latestPrice: number;
    latestSource: string;
    latestTime: string;
    latestUpdate: number;
    latestUpdateTimestamp: string;
    latestVolume: number;
    change: number;
    changePercent: number;
    marketCap: number;
    peRatio: number;
    week52High: number;
    week52Low: number;
    ytdChange: number;
    lastTradeTime: number;
    lastTradeTimeTimestamp: string;
    isUSMarketOpen: boolean;
}
